<!-- sep_5_spinner -->
<template>
  <div v-if="$store.state.loading" class="spinner-overlay">
    <div class="spinner-card">
      <div class="spinner"></div>
      <!-- Show message only if available -->
      <p v-if="$store.state.loadingMessage" class="spinner-text">
        {{ $store.state.loadingMessage }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingSpinner",
};
</script>

<style scoped>
.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(4px);
}

.spinner-card {
  background: #fff;
  padding: 30px 40px;
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: fadeIn 0.5s ease-in-out;
}

.spinner {
  width: 70px;
  height: 70px;
  border: 6px solid #e0e0e0;
  border-top: 6px solid transparent;
  border-radius: 50%;
  background: conic-gradient(#3498db, #8e44ad, #3498db);
  animation: spin 1s linear infinite;
  -webkit-mask: radial-gradient(farthest-side, transparent calc(100% - 6px), black 0);
  mask: radial-gradient(farthest-side, transparent calc(100% - 6px), black 0);
}

.spinner-text {
  margin-top: 20px;
  font-size: 16px;
  font-weight: 500;
  color: #444;
  text-align: center;
  line-height: 1.5;
  white-space: pre-line;
  animation: fadeInUp 0.8s ease-in-out;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.9); }
  to { opacity: 1; transform: scale(1); }
}

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
